"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("@trs/config");
var _utils = require("@trs/utils");
var _LegendItem = _interopRequireDefault(require("./LegendItem.style"));
var _currency = _interopRequireDefault(require("../currency"));
var _LegendItemBoxColor = _interopRequireDefault(require("./LegendItemBoxColor"));
var _input = require("../input");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var LegendItem = /*#__PURE__*/function (_Component) {
  _inherits(LegendItem, _Component);
  var _super = _createSuper(LegendItem);
  function LegendItem(props) {
    var _this;
    _classCallCheck(this, LegendItem);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onTouch", function () {
      if (_this.state.touchStarted) {
        _this.props.onClick();
        _this.stopTap();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "startTap", function () {
      _this.setState({
        touchStarted: true
      }, _this.props.onMouseOver);
    });
    _defineProperty(_assertThisInitialized(_this), "stopTap", function () {
      _this.setState({
        touchStarted: false
      }, _this.props.onMouseOut);
    });
    _this.state = {
      touchStarted: false
    };
    return _this;
  }
  _createClass(LegendItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        boxColor = _this$props.boxColor,
        label = _this$props.label,
        value = _this$props.value,
        percent = _this$props.percent,
        currency = _this$props.currency,
        active = _this$props.active,
        highlightRow = _this$props.highlightRow,
        onMouseOver = _this$props.onMouseOver,
        onMouseOut = _this$props.onMouseOut,
        onClick = _this$props.onClick,
        isAmount = _this$props.isAmount,
        id = _this$props.id,
        className = _this$props.className,
        description = _this$props.description,
        textValue = _this$props.textValue;
      var textValueDisplay = (0, _utils.safeTrim)(textValue);
      return /*#__PURE__*/_react["default"].createElement(_LegendItem["default"], {
        className: className,
        highlightRow: highlightRow,
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        onBlur: onMouseOut,
        onMouseOut: onMouseOut,
        onTouchStart: this.startTap,
        onTouchCancel: this.stopTap,
        onTouchMove: this.stopTap,
        onTouchEnd: this.onTouch,
        active: active,
        onClick: onClick,
        id: id
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "legend-label"
      }, boxColor && /*#__PURE__*/_react["default"].createElement(_LegendItemBoxColor["default"], {
        isNegative: value < 0,
        boxColor: boxColor,
        active: active
      }), label, percent !== null && " (".concat(percent, "%)")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "legend-value"
      }, isAmount && /*#__PURE__*/_react["default"].createElement(_currency["default"], {
        currency: currency,
        decimals: _config.MAX_DECIMALS,
        shouldParseFloat: true
      }, value)), description && /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
        className: "legend-description",
        value: description,
        readOnly: true,
        ariaDescribedBy: id
      }), textValueDisplay && /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
        className: "text-element",
        value: textValueDisplay,
        readOnly: true,
        ariaDescribedBy: id
      }));
    }
  }]);
  return LegendItem;
}(_react.Component);
LegendItem.defaultProps = {
  className: 'legend-item',
  percent: null,
  active: false,
  highlightRow: false,
  onMouseOver: function onMouseOver() {},
  onMouseOut: function onMouseOut() {},
  boxColor: null,
  onClick: function onClick() {},
  id: null,
  isAmount: true,
  description: '',
  textValue: ''
};
LegendItem.propTypes = {
  /** legend item class name */
  className: _propTypes["default"].string,
  /** color of the box before the legend item */
  boxColor: _propTypes["default"].string,
  /** item label */
  label: _propTypes["default"].string.isRequired,
  /** item value */
  value: _propTypes["default"].number.isRequired,
  /** item description */
  description: _propTypes["default"].string,
  /** if the item has an amount or is text only */
  isAmount: _propTypes["default"].bool,
  /** item percentage value */
  percent: _propTypes["default"].number,
  /** item currency value */
  currency: _propTypes["default"].string.isRequired,
  /** flag to indicate if item is hovered */
  active: _propTypes["default"].bool,
  /** if active, the row will be highlighted on mouseOver */
  highlightRow: _propTypes["default"].bool,
  /** updater for when mouse is over item */
  onMouseOver: _propTypes["default"].func,
  /** updater for when mouse leaves the hovered item */
  onMouseOut: _propTypes["default"].func,
  /** action on item click */
  onClick: _propTypes["default"].func,
  /** id of the element */
  id: _propTypes["default"].string,
  textValue: _propTypes["default"].string
};
LegendItem.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onTouch",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "startTap",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "stopTap",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "LegendItem",
  "props": {
    "className": {
      "defaultValue": {
        "value": "'legend-item'",
        "computed": false
      },
      "description": "legend item class name",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "percent": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "item percentage value",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "flag to indicate if item is hovered",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "highlightRow": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "if active, the row will be highlighted on mouseOver",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onMouseOver": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "updater for when mouse is over item",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onMouseOut": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "updater for when mouse leaves the hovered item",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "boxColor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "color of the box before the legend item",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "action on item click",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "id of the element",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isAmount": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "if the item has an amount or is text only",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "description": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "item description",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "textValue": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "label": {
      "description": "item label",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "value": {
      "description": "item value",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "currency": {
      "description": "item currency value",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = LegendItem;
exports["default"] = _default;